var React = require('react');

function Connect270 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1000 1010C448.617 1010 0 556.926 0 0L579.819 0L666.667 0C666.667 185.923 815.906 336.645 1000 336.645L1000 1010Z","fill":"currentColor"}));
}

Connect270.defaultProps = {"width":"1000","height":"1010","viewBox":"0 0 1000 1010","fill":"none"};

module.exports = Connect270;

Connect270.default = Connect270;
